import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Label, Row, Col, Alert } from "reactstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddSubcategory = (props) => {
  const queryParams = useQuery();
  const id = queryParams.get("id") === "" ? null : queryParams.get("id");
  const { register, handleSubmit } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [param, setParam] = useState({
    category_id: "",
    subcategory_name: "",
    description: "",
  });
  const [subcategoryNameError, setSubcategoryNameError] = useState("");
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  const isDuplicateSubcategoryName = (name) => {
    const normalizedName = (name || "").trim().toLowerCase();

    if (!normalizedName) {
      return false;
    }

    return subCategoryList.some((item) => {
      const existingName = (item.subcategory_name || "").trim().toLowerCase();
      const existingId = item.subcategory_id ? String(item.subcategory_id) : "";
      const currentId = param.subcategory_id ? String(param.subcategory_id) : "0";

      return existingName === normalizedName && existingId !== currentId;
    });
  };

  // const insertData = (values) => {
  //   if (isDuplicateSubcategoryName(param.subcategory_name)) {
  //     setSubcategoryNameError("This subcategory name already exists");
  //     return;
  //   }

  //   setLoadInsert(true);
  //   values.subcategory_name = param.subcategory_name;
  //   values.description = param.description;
  //   postMethod("api/masters/product/subcategory/insert", values).then((data) => {
  //     if (data.data[0].valid) {
  //       setSuccess(true);
  //       setTimeout(() => {
  //         props.history.push("/branch/product/subcategory");
  //       }, 2000);
  //     } else {
  //       setLoadInsert(false);
  //     }
  //   });
  // };
const insertData = (values) => {
  // Duplicate check only for new record
  if (!id && isDuplicateSubcategoryName(param.subcategory_name)) {
    setSubcategoryNameError("This subcategory name already exists");
    return;
  }

  setLoadInsert(true);
  values.subcategory_name = param.subcategory_name;
  values.description = param.description;

  postMethod("api/masters/product/subcategory/insert", values).then((data) => {
    if (data.data[0].valid) {
      setSuccess(true);
      setTimeout(() => {
        props.history.push("/branch/product/subcategory");
      }, 2000);
    } else {
      setLoadInsert(false);
    }
  });
};
  const handleDelete = () => {
    const proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/product/subcategory/delete", {
        subcategory_id: param.subcategory_id,
      }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/product/subcategory");
          }, 2000);
        } else {
          setLoadDelete(false);
        }
      });
    }
  };

  const subcategory = () => {
    postMethod("api/masters/product/subcategory/getsubCategory", {
      category_id: param.category_id,
      search: param.subcategory_name,
    }).then((data) => setSubCategoryList(data.data));
  };

  useEffect(() => {
    subcategory();
  }, [param.category_id, param.subcategory_name]);

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      const temp = window.atob(id);
      postMethod("api/masters/product/subcategory/preview", { subcategory_id: temp }).then(
        (data) => {
          setParam(data.data);
          setLoad(false);
        }
      );
    }
    postMethod("api/masters/product/subcategory/getCategory", {}).then((data) =>
      setCategory(data.data)
    );
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="subcategory-editor-form">
        <input
          type="hidden"
          name="subcategory_id"
          value={id == null ? "0" : param.subcategory_id}
          ref={register}
        />
        <div className="card shadow subcategory-editor-card">
          <div className="subcategory-editor-header">
            <div className="subcategory-editor-title">
              <span className="subcategory-editor-icon">
                <i className="fa fa-sitemap"></i>
              </span>
              <div>
                <h3>{id ? "Edit Product Subcategory" : "Add Product Subcategory"}</h3>
                <p>Organize product categories into smaller, searchable groups.</p>
              </div>
            </div>
          </div>

          <div className="card-body subcategory-editor-body">
            <Row>
              <Col lg={7} md={12}>
                <div className="subcategory-editor-section">
                  <Row>
                    <Col md={6} sm={12}>
                      <FormGroup className="subcategory-editor-field">
                        <Label>
                          Category <span>*</span>
                        </Label>
                        <select
                          className="form-control subcategory-editor-input"
                          onChange={(e) => {
                            setParam({ ...param, category_id: e.target.value });
                            setSubcategoryNameError("");
                          }}
                          name="category_id"
                          value={param.category_id}
                          ref={register}
                          required
                        >
                          <option value="">--Select--</option>
                          {category.map((prop, i) => {
                            return (
                              <option key={i} value={prop.category_id}>
                                {prop.category_name}
                              </option>
                            );
                          })}
                        </select>
                      </FormGroup>
                    </Col>
                    <Col md={6} sm={12}>
                      <FormGroup className="subcategory-editor-field">
                        <Label>
                          Subcategory Name <span>*</span>
                        </Label>
                        <Autocomplete
                          id="CategoryName"
                          freeSolo
                          size="small"
                          value={param.subcategory_name || ""}
                          options={subCategoryList.map((option) => option.subcategory_name)}
                          onChange={(event, value) => {
                            setParam({ ...param, subcategory_name: value || "" });
                            setSubcategoryNameError(
  !id && isDuplicateSubcategoryName(value)
    ? "This subcategory name already exists"
    : ""
);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="subcategory-editor-autocomplete"
                              placeholder="Enter subcategory name"
                              required
                              onChange={(e) => {
                                const nextName = e.target.value;
                                setParam({
                                  ...param,
                                  subcategory_name: nextName,
                                });
                              setSubcategoryNameError(
  !id && isDuplicateSubcategoryName(nextName)
    ? "This subcategory name already exists"
    : ""
);
                              }}
                              margin="normal"
                              variant="outlined"
                            />
                          )}
                        />
                        {subcategoryNameError ? (
                          <span className="form-text text-danger">
                            {subcategoryNameError}
                          </span>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup className="subcategory-editor-field mb-0">
                    <Label>Description</Label>
                    <textarea
                      className="form-control subcategory-editor-textarea"
                      id="sub_description"
                      value={param.description}
                      placeholder="Add optional notes for this subcategory"
                      onChange={(e) =>
                        setParam({ ...param, description: e.target.value })
                      }
                    ></textarea>
                  </FormGroup>
                </div>
              </Col>
              <Col lg={5} md={12}>
                <div className="subcategory-editor-info">
                  <span>
                    <i className="fa fa-info-circle"></i>
                  </span>
                  <div>
                    <h5>Quick Note</h5>
                    <p>
                      Select a parent category first, then create a concise
                      subcategory name for product browsing and reports.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">Deleted</Alert> : null}
          </div>

          <div className="subcategory-editor-footer">
            <a
              href="/branch/product/subcategory"
              className="btn subcategory-editor-cancel-btn"
            >
              Cancel
            </a>
            {id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger subcategory-editor-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger subcategory-editor-action-btn"
                >
                  Delete
                </button>
              ))}
            {loadInser ? (
              <button type="button" className="btn btn-primary subcategory-editor-action-btn">
                Saving..
              </button>
            ) : (
              <button type="submit" className="btn btn-primary subcategory-editor-action-btn">
                Save
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddSubcategory;
